// src/App.js
import React from "react";
import "./App.css";
import "./Assets/style/styles.scss";
import "./fonts.css";
import { BrowserRouter } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import { AuthProvider } from "./AuthContext/AuthContext.js";
import AppContent from "./components/App/AppContent.js";
import theme from "./Theme/them.js";
import { ThemeProvider } from "@mui/material/styles";
import { CurrencyProvider } from "./Context/CurrencyContext.js";
import ScrollToTop from "./components/ScrollToTop.js";

function App() {
  return (
    <div className="App">
      <SnackbarProvider autoHideDuration={2000} maxSnack={1}>
        <BrowserRouter>
          <ScrollToTop />
          <ThemeProvider theme={theme}>
            <CurrencyProvider>
              <AuthProvider>
                <AppContent />{" "}
                {/* AppContent handles the header, footer, sidebar, and routes */}
              </AuthProvider>
            </CurrencyProvider>
          </ThemeProvider>
        </BrowserRouter>
      </SnackbarProvider>
    </div>
  );
}

export default App;
